import { NoPayload } from '../commonPayloadTypes';

export enum PortalNotificationEvent {
    LoadNextBatch = 'NotificationPane.LoadNextBatch',
    UnreadFilter = 'NotificationPane.UnreadFilter',
    UncheckTopicPreference = 'NotificationPane.UncheckTopicPreference',
    UncheckTenantPreference = 'NotificationPane.UncheckTenantPreference',
    ReadAll = 'NotificationPane.ReadAll',
    ClickPreferences = 'NotificationPane.ClickPreferences',
    Clear = 'NotificationPane.Clear',
    ClearAll = 'NotificationPane.ClearAll',
    Navigate = 'NotificationPane.Navigate',
}

type LoadNextBatchPayload = {
    page: number;
};

export interface PortalNotificationEventMap {
    [PortalNotificationEvent.LoadNextBatch]: LoadNextBatchPayload;
    [PortalNotificationEvent.UnreadFilter]: NoPayload;
    [PortalNotificationEvent.UncheckTopicPreference]: NoPayload;
    [PortalNotificationEvent.UncheckTenantPreference]: NoPayload;
    [PortalNotificationEvent.ReadAll]: NoPayload;
    [PortalNotificationEvent.ClickPreferences]: NoPayload;
    [PortalNotificationEvent.Clear]: NoPayload;
    [PortalNotificationEvent.ClearAll]: NoPayload;
    [PortalNotificationEvent.Navigate]: NoPayload;
}
